import React from 'react';
import UserInfo from './UserInfo';
import Brand from "./Brand";
import AppName from "./AppName";

const Header = () => (
  <div className="header">
    <div className="container">
      <div className="row">

        <UserInfo/>
        <Brand/>
        <AppName/>

      </div>
    </div>
  </div>
);

export default Header;


// WEBPACK FOOTER //
// ./src/modules/layout/components/Header.js